import Vue from 'vue'
import Router from 'vue-router'
import CA, { reactive, computed, ref } from '@vue/composition-api'
import waitFor from '@iez/lib/wait-for/'
import waitForActively from '@iez/lib/wait-for-actively/'

Vue.use(CA)
Vue.use(Router)

export const scrollBehaviorResult = ref(false)

const router = new Router({
  mode: 'hash',
  scrollBehavior: async (to, from, savedPosition) => {
    scrollBehaviorResult.value = null
    if (savedPosition) {
      const overflowDependency = overflowDependencies.find(({ fullPath }) => fullPath === to.fullPath)
      if (overflowDependency) {
        overflowDependencies.splice(
          overflowDependencies.findIndex(
            ({ fullPath }) => fullPath === overflowDependency.fullPath
          ),
          1
        )
        const getAppContainer = () => document.querySelector('.v-main')
        const appContainer = getAppContainer()
        /* appContainer.style.opacity = 0
        await waitFor({
          dependencies: overflowDependency.value,
          predicate: overflowDependency.predicate
        }) */
        /* await waitForActively(({
          predicate: () =>
            Math.floor(savedPosition.y + window.innerHeight) <= Math.floor(appContainer.getBoundingClientRect().height),
          intervalDuration: 50
        })) */
        /* appContainer.style.opacity = 1 */
      }
      scrollBehaviorResult.value = savedPosition
      return savedPosition
    } else {
      scrollBehaviorResult.value = { x: 0, y: 0 }
      return {
        x: 0,
        y: 0
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  scrollBehaviorResult.value = null
  next()
})

let isLoaded = false
router.afterEach(to => {
  if (!isLoaded) {
    isLoaded = true
    setTimeout(() => {
      window.ReactNativeWebView?.postMessage(JSON.stringify({
        name: `setIsLoaded`,
        params: true
      }))
    }, 1000)
  }
  window.ReactNativeWebView?.postMessage(JSON.stringify({
    name: `analyticsSetCurrentScreen`,
    name: to.name
  }))
})

export default router

export const routes = []

export const routeCurrent = reactive({
  stack: [],
  path: computed(() => routeCurrent.stack[0]?.path),
  name: computed(() => routeCurrent.stack[0]?.name),
  params: computed(() => routeCurrent.stack[0]?.params),
  fullPath: computed(() => routeCurrent.stack[0]?.fullPath),
  query: computed(() => routeCurrent.stack[0]?.query),
  popState: computed(() => routeCurrent.stack[0]?.popState)
})

const { replace } = router
let isReplacing = false
router.replace = function () {
  isReplacing = true
  return replace.apply(router, arguments)
}

let isPopState = false
window.addEventListener(`popstate`, () => {
  isPopState = true
})

router.beforeEach((to, from, next) => {
  if (isPopState) {
    routeCurrent.stack.shift()
    routeCurrent.stack.splice(
      0,
      1,
      {
        ...routeCurrent.stack[0],
        popState: from.name
      }
    )
    isPopState = false
  } else if (isReplacing) {
    routeCurrent.stack.splice(
      0,
      1,
      { ...to }
    )
    isReplacing = false
  } else {
    routeCurrent.stack.unshift({
      ...to
    })
  }
  next()
})

const overflowDependencies = []

export const addOverflowDependency = ({
  dependency,
  predicate
}) => {
  if (!overflowDependencies.find(({ fullPath }) => fullPath === routeCurrent.fullPath)) {
    overflowDependencies.push({
      fullPath: routeCurrent.fullPath,
      value: dependency,
      predicate
    })
  }
}
